import { Component, Vue, Prop } from 'vue-property-decorator';
import Contact from '@/components/Contact/Contact';

@Component({
  components: {
    Contact,
  },
})
export default class DynamicConfirmation extends Vue {
  @Prop({ default: 'default' })
  public suName!: string;
  @Prop({ default: false })
  public showOrderConfirmationMessage!: boolean;
  @Prop({ default: false })
  public showFollowup!: boolean;
  @Prop({ default: false })
  public isInclusion!: boolean;
  @Prop({ default: false })
  public isProFit!: boolean;
  @Prop({ default: '' })
  public confirmationMessage!: string;
  // Props useful to personnalize the confirmation template
  @Prop({ default: false })
  public isDoctor!: boolean;
  @Prop({ default: false })
  public isPharmacist!: boolean;
  @Prop({ default: '' })
  public inclusionType!: string;

  // The component we want to load
  public component: any = null;

  get loader() {
    if (!this.suName) {
      return () => import('./Templates/TemplateDefault/TemplateDefault.vue');
    }
    // Get the first letter of su in upper case and import the component
    const suUcFirst = this.suName.charAt(0).toUpperCase() + this.suName.slice(1);
    return () => import(`./Templates/Template${suUcFirst}/Template${suUcFirst}.vue`);
  }

  protected mounted() {
    this.loader()
      .then(() => {
        this.component = () => this.loader();
      })
      .catch(() => {
        // In case the SU doesn't have a specific template, we load the default one
        this.component = () => import('./Templates/TemplateDefault/TemplateDefault.vue');
      });
  }
}
